import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import UploadMedia from "./../../../helpers/UploadMedia/UploadMedia";
import EmptyItems from "../../../helpers/EmptyItems/EmptyItems";
import { imageAdminContext } from "../../../context/Admin/ImageAdminContext/ImageAdminContext";

const ImageAdmin = () => {
  const image = useSelector((state) => state.meta?.image);

  const {
    homeBanner,
    setHomeBanner,
    menuBanner,
    setMenuBanner,
    serviceBanner,
    setServiceBanner,
    galleryBanner,
    setGalleryBanner,
    homeCarousel,
    setHomeCarousel,
    gallery,
    setGallery,
    handleEditImage,
  } = useContext(imageAdminContext);

  const handleReset = () => {
    setHomeBanner(image?.homeBanner);
    setMenuBanner(image?.menuBanner);
    setServiceBanner(image?.serviceBanner);
    setGalleryBanner(image?.galleryBanner);
    setHomeCarousel(image?.homeCarousel);
    setGallery(image?.gallery);
  };

  const handleAddItem = (type, value) => {
    switch (type) {
      case "homeCarousel":
        setHomeCarousel([...homeCarousel, ""]);
        break;
      case "gallery":
        setGallery([...gallery, ""]);
        break;

      default:
        break;
    }
  };
  const handleEditItem = (type, index, value) => {
    switch (type) {
      case "homeCarousel":
        const homeCarouselItems = [...homeCarousel];
        homeCarouselItems[index] = value;
        setHomeCarousel(homeCarouselItems);
        break;
      case "gallery":
        const galleryItems = [...gallery];
        galleryItems[index] = value;
        setGallery(galleryItems);
        break;

      default:
        break;
    }
  };
  const handleRemoveItem = (type, index) => {
    switch (type) {
      case "homeCarousel":
        setHomeCarousel(homeCarousel?.filter((_, _i) => _i !== index));
        break;
      case "gallery":
        setGallery(gallery?.filter((_, _i) => _i !== index));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!isEmpty(image)) handleReset();
  }, [image]);

  return (
    <>
      <SiteTitle title="مدیریت تصاویر" />

      <div className="container-fluid mt-4">
        <form onSubmit={handleEditImage}>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس بنر صفحه اصلی</div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setHomeBanner(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field bg-dark">
                    <input
                      type="text"
                      id="homeBanner"
                      name="homeBanner"
                      placeholder="آدرس بنر صفحه اصلی"
                      onChange={(e) => setHomeBanner(e.target.value)}
                      value={homeBanner}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس بنر صفحه منو</div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setMenuBanner(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field bg-dark">
                    <input
                      type="text"
                      id="menuBanner"
                      name="menuBanner"
                      placeholder="آدرس بنر صفحه منو"
                      onChange={(e) => setMenuBanner(e.target.value)}
                      value={menuBanner}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس بنر صفحه خدمات</div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setServiceBanner(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field bg-dark">
                    <input
                      type="text"
                      id="serviceBanner"
                      name="serviceBanner"
                      placeholder="آدرس بنر صفحه خدمات"
                      onChange={(e) => setServiceBanner(e.target.value)}
                      value={serviceBanner}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">آدرس بنر صفحه تصاویر</div>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setGalleryBanner(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field bg-dark">
                    <input
                      type="text"
                      id="galleryBanner"
                      name="galleryBanner"
                      placeholder="آدرس بنر صفحه تصاویر"
                      onChange={(e) => setGalleryBanner(e.target.value)}
                      value={galleryBanner}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">
              تصاویر اسلایدر صفحه اصلی
            </div>
            <div className="card-body">
              <button
                type="button"
                className="kf-btn mb-3"
                onClick={() => handleAddItem("homeCarousel")}
              >
                <span>افزودن</span>
              </button>
              {isEmpty(homeCarousel) ? (
                <EmptyItems />
              ) : (
                <>
                  {homeCarousel.map((_item, index) => (
                    <div className="row" key={index}>
                      <div className="col-12 col-md-5 col-lg-2">
                        <UploadMedia
                          callback={(val) =>
                            handleEditItem("homeCarousel", index, val)
                          }
                        />
                      </div>
                      <div className="col-12 col-md-5 col-lg-8">
                        <div className="kf-field bg-dark">
                          <input
                            type="text"
                            name="homeCarousel"
                            placeholder="آدرس تصویر اسلایدر صفحه اصلی"
                            onChange={(e) =>
                              handleEditItem(
                                "homeCarousel",
                                index,
                                e.target.value
                              )
                            }
                            value={homeCarousel[index]}
                          />
                          <i className="la la-image" />
                        </div>
                      </div>

                      <div className="col-12 col-md-2">
                        <button
                          type="button"
                          className="btn btn-danger w-100 text-white mt-1"
                          onClick={() =>
                            handleRemoveItem("homeCarousel", index)
                          }
                        >
                          <span>حذف</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className="card mb-2">
            <div className="card-header text-dark">تصاویر صفحه تصاویر</div>
            <div className="card-body">
              <button
                type="button"
                className="kf-btn mb-3"
                onClick={() => handleAddItem("gallery")}
              >
                <span>افزودن</span>
              </button>
              {isEmpty(gallery) ? (
                <EmptyItems />
              ) : (
                <>
                  {gallery.map((_item, index) => (
                    <div className="row" key={index}>
                      <div className="col-12 col-md-5 col-lg-2">
                        <UploadMedia
                          callback={(val) =>
                            handleEditItem("gallery", index, val)
                          }
                        />
                      </div>
                      <div className="col-12 col-md-5 col-lg-8">
                        <div className="kf-field bg-dark">
                          <input
                            type="text"
                            name="gallery"
                            placeholder="آدرس تصویر صفحه تصاویر"
                            onChange={(e) =>
                              handleEditItem("gallery", index, e.target.value)
                            }
                            value={gallery[index]}
                          />
                          <i className="la la-image" />
                        </div>
                      </div>

                      <div className="col-12 col-md-2">
                        <button
                          type="button"
                          className="btn btn-danger w-100 text-white mt-1"
                          onClick={() => handleRemoveItem("gallery", index)}
                        >
                          <span>حذف</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>ویرایش</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={handleReset}
            >
              بازنشانی
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ImageAdmin;
